import { render, staticRenderFns } from "./gameXingxingConfig.vue?vue&type=template&id=9c7e6e20&"
import script from "./gameXingxingConfig.vue?vue&type=script&lang=js&"
export * from "./gameXingxingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7e6e20')) {
      api.createRecord('9c7e6e20', component.options)
    } else {
      api.reload('9c7e6e20', component.options)
    }
    module.hot.accept("./gameXingxingConfig.vue?vue&type=template&id=9c7e6e20&", function () {
      api.rerender('9c7e6e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameXingxingConfig.vue"
export default component.exports